enum RoomType {
  alcoveLeftWall = '8fdf8d6a-0e1f-4d5c-bbf4-4eb28d1c15cf',
  alcoveRightWall = '2d28373c-d48e-4de4-89c3-9c496a7563c5',
  screensOnly = '67151b23-fac9-47a2-877e-63b8765936b2',
  partsOnly = 'd96e0d8c-5909-41bb-b93c-a14369ee86f4',
  freeStanding = '7f0fa8c1-7ee0-4be2-89a7-1406575f93f5',
}

export default RoomType;
